// extracted by mini-css-extract-plugin
export default {"moreOptionsIcon":"CommentOptions_moreOptionsIcon__JBFWp","moreOptionsSubcommentIcon":"CommentOptions_moreOptionsSubcommentIcon__Rk8sC"};